import React from 'react';

import {
  Button,
  GoogleLogo,
  MicrosoftLogo,
  Stack,
  Text,
} from '@eluve/components';

export interface SocialLoginButtonsProps {
  isMicrosoftLoginEnabled?: boolean;
  onGoogleLogin: () => Promise<void>;
  onMicrosoftLogin: () => Promise<void>;
  disabled?: boolean;
}

export const SocialLoginButtons: React.FC<SocialLoginButtonsProps> = ({
  isMicrosoftLoginEnabled = true,
  onGoogleLogin,
  onMicrosoftLogin,
  disabled = false,
}) => {
  return (
    <Stack align="center" gap={2}>
      {/* Divider */}
      <Stack className="my-2" gap={2} direction="horizontal">
        <div className="h-0.5 w-full bg-border-primary"></div>
        <Text inline className="flex-1 p-4 whitespace-nowrap">
          or
        </Text>
        <div className="h-0.5 w-full bg-border-primary"></div>
      </Stack>

      {/* Social Login Buttons */}
      <Stack
        className={isMicrosoftLoginEnabled ? undefined : 'flex-row'}
        gap={2}
      >
        <Button
          variant="outline"
          onClick={onGoogleLogin}
          className="flex w-full items-center justify-between px-4"
          disabled={disabled}
        >
          <Stack
            className="w-1/4 shrink-0"
            direction="horizontal"
            justify="end"
            fullWidth={false}
            align="stretch"
          >
            <GoogleLogo className="size-5" />
          </Stack>
          <span className="w-3/4 flex-1 pl-3 text-left">
            Continue with Google
          </span>
        </Button>
        {isMicrosoftLoginEnabled && (
          <Button
            variant="outline"
            onClick={onMicrosoftLogin}
            className="flex w-full items-center justify-between px-4"
            disabled={disabled}
          >
            <Stack
              className="w-1/4"
              direction="horizontal"
              justify="end"
              fullWidth={false}
              align="stretch"
            >
              <MicrosoftLogo className="size-5 shrink-0" />
            </Stack>
            <span className="w-3/4 flex-1 pl-3 text-left">
              Continue with Microsoft
            </span>
          </Button>
        )}
      </Stack>
    </Stack>
  );
};
